export default __webpack_public_path__ + "static/media/tamGiangHistogram.4c857c43.png";